/* Cart button in the top-right of the header on every page, with a live item count (18 Oct 2026) */
(function () {
  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 3.5h2.2l2.5 11a1.6 1.6 0 0 0 1.6 1.2h8.4a1.6 1.6 0 0 0 1.5-1.1l2.1-6.6H6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9.6" cy="19.8" r="1.6"/><circle cx="17" cy="19.8" r="1.6"/></svg>';
  function css() {
    if (document.getElementById('agcart-css')) return;
    var s = document.createElement('style'); s.id = 'agcart-css';
    s.textContent = '.agcart{position:relative;display:inline-grid;place-items:center;flex:0 0 auto;width:44px;height:44px;margin-left:.6rem;margin-right:-.4rem;border-radius:50%;color:#fff;text-decoration:none}' +
      '.agcart:hover,.agcart:focus-visible{background:rgba(255,255,255,.12)}' +
      '.agcart svg{width:25px;height:25px;fill:currentColor}' +
      '.agcart__n{position:absolute;top:1px;right:-1px;min-width:19px;height:19px;padding:0 5px;box-sizing:border-box;border-radius:10px;background:var(--gold,#F5B335);color:var(--black,#211E16);font:800 12px/19px "Dosis",system-ui,sans-serif;text-align:center}' +
      '.agcart__n[hidden]{display:none}' +
      /* one cart (19 Oct 2026): the old bottom-right bag button is retired; the header cart is the only cart */
      '#bagBtn,#bag{display:none!important}';
    document.head.appendChild(s);
  }
  function count() {
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = c.item_count || 0;
        document.querySelectorAll('.agcart').forEach(function (a) {
          var b = a.querySelector('.agcart__n');
          b.textContent = n > 99 ? '99+' : n; b.hidden = !n;
          a.setAttribute('aria-label', n ? 'Cart, ' + n + (n === 1 ? ' item' : ' items') : 'Cart');
        });
      }).catch(function () {});
  }
  function go() {
    css();
    document.querySelectorAll('header.bar .bar__in').forEach(function (bar) {
      if (bar.querySelector('.agcart')) return;
      var a = document.createElement('a'); a.href = '/cart'; a.className = 'agcart'; a.setAttribute('aria-label', 'Cart');
      a.innerHTML = ICON + '<span class="agcart__n" hidden>0</span>';
      bar.appendChild(a);
    });
    count();
    oneCartStart();
  }
  /* refresh the count whenever something is added, changed or removed */
  var f = window.fetch;
  if (f) window.fetch = function (u) {
    var p = f.apply(this, arguments);
    try { var s = typeof u === 'string' ? u : (u && u.url) || ''; if (/\/cart\/(add|change|update|clear)/.test(s)) p.then(function () { setTimeout(count, 200); }, function () {}); } catch (e) {}
    return p;
  };
  addEventListener('pageshow', function (e) { if (e.persisted) count(); });

  /* ---------------------------------------------------------------------------
     ONE CART (19 Oct 2026)
     The new product and shop pages used to keep a separate "bag" in the shopper's
     browser (localStorage "ag-bag"), so items added there never reached Shopify's
     real cart (the header cart icon). Every time those pages save the bag, we now
     send the newly added items to the real Shopify cart and empty the bag, so there
     is only one cart and one checkout.
     ------------------------------------------------------------------------- */
  var KEY = 'ag-bag', queue = Promise.resolve(), ls = null;
  try { ls = window.localStorage; } catch (e) {}
  function parse(v) { try { var a = JSON.parse(v || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function addToCart(items) {
    items = items.filter(function (i) { return i.id && i.quantity > 0; });
    if (!items.length) return Promise.resolve(null);
    return f.call(window, '/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).catch(function (err) {
      /* if one item fails (e.g. sold out), still add the others one by one */
      if (items.length < 2) throw err;
      return items.reduce(function (p, it) { return p.then(function () { return addToCart([it]).catch(function () {}); }); }, Promise.resolve());
    }).then(function (j) { setTimeout(count, 200); return j; });
  }
  function clearBag() {
    try { if (ls && rawRemove) rawRemove.call(ls, KEY); } catch (e) {}
    try { if (typeof window.agBag === 'function') { var b = window.agBag(); if (b && b.length) b.length = 0; } } catch (e) {}
  }
  function afterAdd(ok, err) {
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
      var n = c.item_count || 0, msg = ok ? 'Added. Your cart has ' + n + ' item' + (n === 1 ? '' : 's') + '.' : ((err && (err.description || err.message)) || 'Sorry, that could not be added. Please try again.');
      var t = document.getElementById('pdAddedT'); if (t) t.textContent = msg;
      var pa = document.getElementById('ppAdded'); if (pa && !ok) pa.textContent = msg;
    }).catch(function () {});
    var co = document.getElementById('pdCheckout'); if (co) co.href = '/checkout';
  }
  var rawSet = null, rawRemove = null;
  if (ls) {
    try {
      var proto = Object.getPrototypeOf(ls);
      rawSet = proto.setItem; rawRemove = proto.removeItem;
      proto.setItem = function (k, v) {
        if (this === ls && k === KEY) {
          var before = parse(rawGet()), after = parse(v), was = {};
          before.forEach(function (x) { was[x.id] = (was[x.id] || 0) + (+x.q || 0); });
          var adds = [];
          after.forEach(function (x) { var d = (+x.q || 0) - (was[x.id] || 0); if (d > 0) adds.push({ id: +x.id, quantity: d }); });
          var r = rawSet.apply(this, arguments);
          if (adds.length) {
            queue = queue.then(function () { return addToCart(adds); })
              .then(function () { clearBag(); afterAdd(true); }, function (e) { clearBag(); afterAdd(false, e); });
          }
          /* the product page sets its checkout link right after saving; point it at the real checkout instead */
          setTimeout(function () { var co = document.getElementById('pdCheckout'); if (co) co.href = '/checkout'; }, 0);
          return r;
        }
        return rawSet.apply(this, arguments);
      };
    } catch (e) { rawSet = null; }
  }
  function rawGet() { try { return Object.getPrototypeOf(ls).getItem.call(ls, KEY); } catch (e) { return null; } }
  function oneCartStart() {
    if (!ls || !rawSet) return;
    /* move anything left in an old browser-only bag into the real cart, once */
    var old = parse(rawGet());
    if (old.length) {
      clearBag();
      queue = queue.then(function () { return addToCart(old.map(function (x) { return { id: +x.id, quantity: +x.q || 1 }; })); }).catch(function () {});
    }
    var co = document.getElementById('pdCheckout'); if (co) co.href = '/checkout';
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', go) : go();
})();
